import { useEffect } from "react";

const useTheme = () => {
  const theme = 'dark';

  useEffect(() => {
    document.documentElement.className = 'dark';
  }, []);

  return { theme };
};

export default useTheme;
